import script from "./ParticipantsTableAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantsTableAdmin.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantsTableAdmin.vue?vue&type=style&index=0&id=457c48dd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457c48dd"]])

export default __exports__